export type DocumentsResponse =  Document[]
export interface Document {
  id?: string | number
  fileLink: string
  documentType: DocumentType
  label: string
  bookingReference?: string
  isActive?: boolean
  includeInVoucher?: boolean
}

export enum DocumentType {
  BookingConfirmation = 'booking-confirmation',
  Vouchers = 'vouchers',
  Invoice = 'invoice',
  InsuranceSkieur = 'insurance-skieur',
  InsuranceAnnulation = 'insurance-annulation',
  InsuranceAnnulationCOSOG = 'insurance-annulation-cosog',
}
